<template>
  <div role="main" class="main">
    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li class="active">Dashboard Pendaftaran</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div class="container" style="z-index: -1">
      <!--modal here -->
      <div class="row">
        <div class="col-md-3">
          <sidebar />
        </div>
        <div class="col-md-9">
          <!-- loading here -->
          <!--<flash-message></flash-message>
          <center>
            <pulse-loader style="margin: 15px" :loading="$store.state.formData.loading" color="#696969" size="10px"></pulse-loader>
          </center>
          -->
          <div class="row">
            <div class="col-md-12">
              <div>
                <h2><i class="fa fa-newspaper-o"></i> Artikel</h2>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="col-md-6"
                      style="min-height: 520px"
                      v-for="item in $store.state.artikel.randomThree.filter(
                        el => el
                      )"
                      :key="item.id"
                    >
                      <div class="recent-posts">
                        <article class="post">
                          <div class="post-image single mb-lg">
                            <img :src="item.foto" class="img-thumbnail" />
                          </div>
                          <h4 class="heading-primary">
                            <a
                              @click="() => goToDetailArtikel(item.id_berita)"
                              style="cursor: pointer"
                              s
                            >
                              {{ item.judul }}
                            </a>
                          </h4>
                          <div class="post-meta pl-none">
                            <span
                              ><i class="fa fa-calendar"></i>
                              {{ item.tgl_posting }}</span
                            >
                          </div>
                          <!-- <p>
                            <br />
                            <a
                              class="read-more"
                              @click="() => goToDetailArtikel(item.id_berita)"
                              style="cursor: pointer"
                              >baca lebih lanjut
                              <i class="fa fa-angle-right"></i
                            ></a>
                          </p> -->
                        </article>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row visible-xs">
            <div class="col-md-12">
              <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailPengumuman(item.id_pengumuman)"
                    style="cursor: pointer"
                    >{{ item.judul }}</a
                  >
                </li>
              </ul>
              <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.artikel.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailArtikel(item.id_berita)"
                    style="cursor: pointer"
                  >
                    {{ item.judul }}</a
                  >
                </li>
                <li>
                  <a @click="() => goToCardArtikel()" style="cursor: pointer">
                    <h6 class="heading-primary">
                      Selengkapnya...
                    </h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from "../chat/Chat";

export default {
  methods: {
    goToDetailArtikel(id) {
      this.$store.dispatch("getOneArtikel", id);
      this.$router.push({ name: "ArtikelDetail", params: { id_berita: id } });
    }
  },
  components: { Chat }
};
</script>



// WEBPACK FOOTER //
// src/page/information/ArtikelCardList.vue